"use client"

import { useCallback } from "react"
import { User, Palette, LogOut } from "lucide-react"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu"
import AvatarBase from "@/components/user/iavatar"
import { useAuthStore, useProfileStore } from "@/stores"
import { useComponentsTranslations } from "@/hooks/use-translations"

export function UserMenu() {
  // Get store states
  const signOut = useAuthStore((state) => state.signOut)
  const profileName = useProfileStore((state) => state.profile?.name || 'User')
  const t = useComponentsTranslations()
  const triggerId = "header-user-menu-trigger"
  const contentId = "header-user-menu-content"

  // Memoize navigation handlers
  const handleProfileClick = useCallback(() => {
    window.location.href = "/settings"
  }, [])

  const handleAppearanceClick = useCallback(() => {
    window.location.href = "/settings?tab=appearance"
  }, [])

  return (
    <div className="flex items-center gap-2 cursor-pointer">
      <DropdownMenu>
        <DropdownMenuTrigger asChild id={triggerId}>
          <Button variant="ghost" size="icon" className="rounded-full transition-transform duration-200 cursor-pointer">
            <AvatarBase size="sm" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          id={contentId}
          align="end"
          className="w-full animate-in fade-in slide-in-from-top-1 shadow-lg"
        >
          <DropdownMenuLabel>{profileName}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="cursor-pointer" onClick={handleProfileClick}>
            <User className="mr-2 h-4 w-4" />
            {t('profile')}
          </DropdownMenuItem>

          <DropdownMenuItem className="cursor-pointer" onClick={handleAppearanceClick}>
            <Palette className="mr-2 h-4 w-4" />
            {t('appearance')}
          </DropdownMenuItem>

          <DropdownMenuItem className="cursor-pointer" onClick={signOut}>
            <LogOut className="mr-2 h-4 w-4" />
            {t('logOut')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
